export default __webpack_public_path__ + "static/media/10.17f7aad9.png";